import { Button } from '@synoptic/ui-kit/button/button.tsx';
import {
  ModalContent,
  ModalHeader,
  ModalTitle,
} from '@synoptic/ui-kit/modal/modal.js';
import { useIsTablet } from '@synoptic/ui-kit/responsive/hooks.js';
import { useControllableState } from '@synoptic/ui-kit/utils/use-controllable-state.js';
import { useState } from 'react';
import { UserCardFragmentFragment } from '@/__generated__/graphql.ts';
import { listForm } from '@/components/stream-deck/list-form/list-form.css.ts';
import {
  buttonsContainer,
  subTitle,
} from '@/components/streams/stream-invite/invite-users-modal.css.ts';
import { useAddUsersToStream } from '@/components/streams/use-add-users-to-stream.ts';
import { AdminUsersMultiSelectCombobox } from '@/components/users/users-multi-select-combobox/admin-users-multi-select-combobox.tsx';
import { multiSelectComboboxWrapper } from './add-users-to-stream-modal.css.ts';

const MAX_USERS = 25;

export const AddUsersToStreamModal = ({
  onOpenChange,
  streamId,
}: {
  onOpenChange: (open: boolean) => void;
  streamId: string;
}) => {
  const isTablet = useIsTablet();
  const [addUsersToStream, { loading }] = useAddUsersToStream(streamId);

  const [selectedUsers, setSelectedUsers] = useControllableState<
    UserCardFragmentFragment[]
  >({
    defaultValue: [],
  });

  const [error, setError] = useState<string | undefined>(undefined);

  const handleSubmit = async () => {
    // clear prev errors
    setError(undefined);

    if (selectedUsers.length > MAX_USERS) {
      setError(`You can only add up to ${MAX_USERS} users at a time`);
      return;
    }

    try {
      const usersToAdd = selectedUsers.map((user) => user.id);
      await addUsersToStream(usersToAdd);
      onOpenChange(false);
    } catch {
      // catch
    }
  };

  return (
    <ModalContent>
      <ModalHeader>
        <ModalTitle>Add users</ModalTitle>
      </ModalHeader>

      <div className={listForm}>
        <div className={subTitle}>
          Type name or a username of those who you want to add to stream.
        </div>

        <AdminUsersMultiSelectCombobox
          selectedUsers={selectedUsers}
          setSelectedUsers={setSelectedUsers}
          error={error}
          setError={setError}
          wrapperClassName={multiSelectComboboxWrapper}
        />

        <div className={buttonsContainer}>
          <Button
            loading={loading}
            disabled={selectedUsers.length < 1}
            size={isTablet ? 'large' : 'medium'}
            onClick={handleSubmit}
          >
            Add users
          </Button>
        </div>
      </div>
    </ModalContent>
  );
};
